import React from 'react'
import classnames from 'classnames'

import { Item } from '../../../core/items'
import { getItemTranslation } from '../../../core/i18n'
import { LANGUAGE_CODES, SupportedLanguageCode } from '../../../core/i18n'
import { itemInfoTableContent, strings } from './each-item-content'
import styles from '../../styles/modules/table.module.scss'

interface Props {
  item: Item
  activeLanguage: SupportedLanguageCode
}

const ItemInfoTable: React.FC<Props> = props => {
  const { activeLanguage } = props

  return (
    <div
      className={classnames({
        [styles.wrapper]: true,
        [styles.stocker]: true,
      })}
    >
      <table className={`${styles.container} ${styles.itemInfoTable}`}>
        <tbody>
          <tr className={styles.rowStatic}>
            <td className={styles.cell}>{itemInfoTableContent.name}</td>
            <td className={styles.cell}>
              {activeLanguage === LANGUAGE_CODES.JAPANESE
                ? props.item.name
                : getItemTranslation(
                    props.item.itemTranslations,
                    LANGUAGE_CODES.ENGLISH
                  )?.name || strings.notSet}
            </td>
          </tr>
          <tr className={styles.rowStatic}>
            <td className={styles.cell}>{itemInfoTableContent.price}</td>
            <td className={styles.cell}>{props.item.price}</td>
          </tr>
          <tr className={styles.rowStatic}>
            <td className={styles.cell}>
              {itemInfoTableContent.disposalSeconds}
            </td>
            <td className={styles.cell}>{props.item.disposalSeconds}</td>
          </tr>
          <tr className={styles.rowStatic}>
            <td className={styles.cell}>{itemInfoTableContent.cupType}</td>
            <td className={styles.cell}>{props.item.cupType}</td>
          </tr>
          <tr className={styles.rowStatic}>
            <td className={styles.cell}>{itemInfoTableContent.color}</td>
            <td className={styles.cell}>{props.item.color}</td>
          </tr>
          <tr className={styles.rowStatic}>
            <td className={styles.cell}>{itemInfoTableContent.description}</td>
            <td className={styles.cell}>
              {activeLanguage === LANGUAGE_CODES.JAPANESE
                ? props.item.description
                : getItemTranslation(
                    props.item.itemTranslations,
                    LANGUAGE_CODES.ENGLISH
                  )?.description || strings.notSet}
            </td>
          </tr>
          <tr className={styles.rowStatic}>
            <td className={styles.cell}>{itemInfoTableContent.story}</td>
            <td className={styles.textCell}>
              {activeLanguage === LANGUAGE_CODES.JAPANESE
                ? props.item.story
                : getItemTranslation(
                    props.item.itemTranslations,
                    LANGUAGE_CODES.ENGLISH
                  )?.story || strings.notSet}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  )
}

export default ItemInfoTable
